import {
	ADD_QUOTATION_SUCCESS,
	APPROVE_QUOTATION_SUCCESS,
	CLEAN_REDUCER,
	CLEAR_SESSION,
	DENY_QUOTATION_SUCCESS,
	FETCH_QUOTATION_COUNT,
	FETCH_SELLER_INVOICES,
	GET_QUOTATION,
	GET_QUOTATIONS,
	QUOTATION_INVOICED_SUCCESS,
	QUOTATION_PROFORMA_SUCCESS,
	QUOTATION_RENEWED,
	SET_QUOTATION_TO_ADD,
	UPDATE_PAGE,
	UPDATE_SEARCH,
} from './actionTypes';

const initState = {
	quotations: [],
	quotation: {},
	count: 0,
	search: '',
	page: 1,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case UPDATE_SEARCH:
			return {
				...state,
				search: action.search,
			};
		case UPDATE_PAGE:
			return {
				...state,
				page: action.page,
			};
		case GET_QUOTATIONS:
			return {
				...state,
				quotations: action.quotations,
			};
		case FETCH_QUOTATION_COUNT:
			return {
				...state,
				count: action.count,
			};
		case ADD_QUOTATION_SUCCESS:
			return {
				...state,
				quotation: action.quotation,
			};
		case GET_QUOTATION:
			return {
				...state,
				quotation: action.quotation,
			};
		case SET_QUOTATION_TO_ADD:
			return {
				...state,
				quotation: action.quotation,
			};
		case FETCH_SELLER_INVOICES:
			return {
				...state,
				sellerInvoiceIds: action.sellerInvoiceIds,
			};
		case DENY_QUOTATION_SUCCESS:
			return state;
		case APPROVE_QUOTATION_SUCCESS:
			return state;
		case QUOTATION_INVOICED_SUCCESS:
			return state;
		case QUOTATION_PROFORMA_SUCCESS:
			return state;
		case QUOTATION_RENEWED:
			return state;
		case CLEAN_REDUCER:
			return initState;
		case CLEAR_SESSION:
			return initState;
		default:
			return state;
	}
};

export default reducer;
